// src/components/Header.js
import React, { useContext } from 'react';
import './Header.css';
import { useTheme } from '../../contexts/ThemeContext';
import { NavLink } from 'react-router-dom';
import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { AuthContext } from '../../contexts/AuthContext';

const Header = () => {
  const { theme, toggleTheme } = useTheme();
  const { isAuthenticated, logout, user } = useContext(AuthContext);

  const handleLogout = () => {
    logout();
  };

  // Function to get the theme icon path
  const getThemeIconPath = () => {
    return theme === 'dark' ? '/theme/dark_mode.png' : '/theme/light_mode.png';
  };

  return (
    <Navbar expand="lg">
      <Container>
        <Navbar.Brand href="/">
          <Image src="/logo512.png" width="25" className="mr-2 logo-image" />
          FitOps
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-between">
          <Nav className="mr-auto">
            {isAuthenticated && (
              <>
                <Nav.Link as={NavLink} to="/overview">Overview</Nav.Link>
                <Nav.Link as={NavLink} to="/recentactivities">Recent Activities</Nav.Link>
                <Nav.Link as={NavLink} to="/statistics">Statistics</Nav.Link>
              </>
            )}
            <Nav.Link as={NavLink} to="/rules">Rules</Nav.Link>
          </Nav>
          <Nav style={{ marginRight: '20px' }}>
            <Nav.Link onClick={toggleTheme}>
              <Image src={getThemeIconPath()} width="25" />
            </Nav.Link>
            {user && <Nav.Link as={NavLink} to="/activity">Register Activity</Nav.Link>}
            {user && <Nav.Link as={NavLink} to={`/profile/${user.Username}`}>My Profile</Nav.Link>}
            {isAuthenticated ? (
              <Nav.Link onClick={handleLogout}>Logout</Nav.Link>
            ) : (
              <Nav.Link as={NavLink} to="/login">Login</Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
